import '../scss/editor.scss';

console.log('child theme loaded')